import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/Navbar.css';
import './styles/webstyle.css';
import './styles/mobilestyle.css';
import './styles/tabletstyle.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);